export function initContacted() {
}
